import { render } from "./Cases.vue?vue&type=template&id=33ddd7d0&ts=true"
import script from "./Cases.vue?vue&type=script&lang=ts"
export * from "./Cases.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__